import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useTheme } from "@/lib/theme";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { apiErrorMessage } from "@/lib/apiError";

export default function VerifyEmail() {
  const [sp] = useSearchParams();
  const { branding } = useTheme();
  const [state, setState] = useState({ status: "verifying" });

  useEffect(() => {
    const token = sp.get("token");
    if (!token) {
      setState({ status: "error", message: "Missing token." });
      return;
    }
    api.post("/auth/verify-email", { token })
      .then((r) => setState({ status: "ok", email: r.data.email }))
      .catch((e) => setState({ status: "error", message: apiErrorMessage(e, "Could not verify.") }));
  }, [sp]);

  return (
    <div className="min-h-screen grid place-items-center bg-background p-6">
      <div className="border border-border p-10 max-w-md text-center" data-testid={`verify-state-${state.status}`}>
        {state.status === "verifying" && (
          <>
            <Loader2 className="w-10 h-10 mx-auto mb-4 animate-spin text-primary" />
            <h1 className="heading-display text-2xl">Verifying your email…</h1>
          </>
        )}
        {state.status === "ok" && (
          <>
            <CheckCircle2 className="w-12 h-12 mx-auto mb-4 text-emerald-500" />
            <h1 className="heading-display text-2xl mb-2">You're verified</h1>
            <p className="text-muted-foreground text-sm mb-6">{state.email} is now confirmed.</p>
            <Link to="/app"><Button className="rounded-none" data-testid="verify-open-app-btn">Open {branding.platform_name}</Button></Link>
          </>
        )}
        {state.status === "error" && (
          <>
            <XCircle className="w-12 h-12 mx-auto mb-4 text-red-500" />
            <h1 className="heading-display text-2xl mb-2">Verification failed</h1>
            <p className="text-muted-foreground text-sm mb-6">{state.message}</p>
            <Link to="/login"><Button className="rounded-none" data-testid="verify-back-btn">Back to login</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
